import React from 'react'
import GridForm from './grid-form';
import Input from './input';
import Button from './button';
import Form from './form';
import { FormDelegate, formValidators } from '../utils';

class PasswordReset extends React.Component {
    constructor(props) {
        super(props);

        this.formDelegate = new FormDelegate();
        this.formDelegate.onSubmit((output, valid) => this.handleSubmit(output, valid));
        this.formDelegate.onChange((output, valid) => this.handleChange(output, valid));

        this.state = {
            error: ''
        }
    }

    handleSubmit(output, valid) {
        if (valid) {
            if (typeof this.props.onSubmit === 'function') {
                this.props.onSubmit(output);
            }
        } else {
            this.setState({
                error: this.formDelegate.getErrors()[0]
            });
        }
    }

    handleChange() {
        this.setState({
            error: this.formDelegate.getErrors()[0]
        });
    }

    render () {
        let newPassword = this.formDelegate.inputs.newPassword || {};

        return (
            <div className={['component-password-reset', this.props.className]}>
                <Form onSubmit={(e) => this.formDelegate.submit(e)}>
                    <GridForm>
                        <div className="form-group">
                            <label className="form-control">Current Password</label>
                            <Input delegate={this.formDelegate} validators={formValidators.required('Please enter your current password')} className="form-control" name="currentPassword" type="password" />
                        </div>
                        <div className="form-group">
                            <label className="form-control">New Password</label>
                            <Input delegate={this.formDelegate} validators={formValidators.required('Please enter a new password.')} className="form-control" name="newPassword" type="password" />
                        </div>
                        <div className="form-group">
                            <label className="form-control">Confirm Password</label>
                            <Input
                                delegate={this.formDelegate}
                                validators={
                                    [
                                        formValidators.required('Please confirm the new password.'),
                                        value => newPassword.value === value ? false : 'Passwords don\'t match'
                                    ]
                                }
                                className="form-control" name="confirmPassword" type="password" />
                        </div>
                    </GridForm>
                    <div className="form-error">{this.state.error}</div>
                    <div className="form-footer">
                        <Button className="primary" type="submit">Submit</Button>
                    </div>
                </Form>
            </div>
        )
    }
}

export default PasswordReset;



// WEBPACK FOOTER //
// ./web-app/components/password-reset.jsx